'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconNumberList, iconNumberListTag } from '@ni/nimble-components/dist/esm/icons/number-list';
import { wrap } from '../../utilities/react-wrapper';

export type { IconNumberList };
export { iconNumberListTag };
export const NimbleIconNumberList = wrap(IconNumberList);